import React from 'react';

export class FontTable extends React.Component {
  constructor(props) {
    super(props);
  }

  renderTable() {
    return (() => {
      const result = [];
      for (let index = 0; index < this.props.fontFamilies.length; index++) {
        var targetTheme;
        const font = this.props.fontFamilies[index];
        if (font.theme_id === null) {
          targetTheme = 0;
        } else {
          targetTheme = font.theme_id;
        }

        const deleteUrl = `/admin/theme/${targetTheme}/styles/${font.id}/delete`;
        const editUrl = `/admin/theme/${targetTheme}/styles/${font.id}/edit`;
        const editId = `edit-font-${font.id}`;
        const deleteId = `delete-font-${font.id}`;

        result.push(<tr key={index}>
          <td>{font.name}</td>
            <td>
              <div className="action_button left">
                <a id={editId} href={editUrl} className="link btn-color" aria-label="Edit Custom Font">Edit Settings</a>
                <a id={deleteId} href={deleteUrl} className="link btn-color" aria-label="Delete Custom Font" data-method="delete" data-confirm="Are you sure you want to delete this custom font? This action cannot be undone.">Delete Font</a>
              </div>
          </td>
        </tr>);
      }
      return result;
    })();
  }

  render() {
    return <table border="0" className="item-list footable-loaded footable">
      <thead>
        <tr>
          <th>Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody className="theme-listing">
        {this.renderTable()}
      </tbody>
    </table>;
  }
}
